<template lang="pug">
.box
    .box-header.dker
        h3 Inventory
    .box-divider.m-a-0
    .box-body
        .row
            .col-md-12
                p.pull-right
                    label.md-switch
                        input.has-value(
                            type="checkbox",
                            :checked="product.track_stock",
                            :disabled="isCompositeComponent",
                            @change="updateProductAttr($event.target.checked, 'track_stock')",
                        )
                        i.green
                p
                    | Track inventory for this product 
                    i.material-icons(
                        v-show="isCompositeComponent",
                        data-toggle="tooltip",
                        data-placement="auto",
                        title="Disable stock tracking is not allowed. Product is a component of end product"
                    ) info
                
            .col-md-12(v-show="trackStock", v-if="!isCompositeComponent && !originalHasInventories && !originalHasComposites")
                p.pull-right
                    label.md-switch
                        input.has-value(
                            type="checkbox",
                            :checked="product.inventory_type == 0",
                            @change="setInventoryType"
                        )
                        i.green
                p
                    | End product Item 
                    i.material-icons(
                        data-toggle="tooltip",
                        data-placement="auto",
                        title="End product item contains a specified quantity of other items"
                    ) help
        
    stock-inventory(v-if="trackStock && isTypeInventory")
    stock-composite(v-if="trackStock && isTypeComposite")

</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import stockInventory from './product-stock-inventory.vue';
import stockComposite from './product-stock-composite.vue';

export default {
    inject: ['$validator'],

    components: {
        stockInventory,
        stockComposite,
    },

    computed: {
        ...mapGetters('product', [
            'product',
            'trackStock',
            'original',
            'originalHasInventories',
            'originalHasComposites',
            'trackStock',
            'isTypeInventory',
            'isTypeComposite',
            'isCompositeComponent',
        ]),

        variants() {
            return this.product.variants;
        },
    },

    mounted() {
        this.$nextTick(() => $('[data-toggle="tooltip"]').tooltip());
    },

    methods: {
        ...mapActions('product', ['setProductAttribute']),

        updateProductAttr(value, key) {
            this.setProductAttribute({ key, value });
        },

        setInventoryType(e) {
            const value = e.target.checked == true ? 0 : 1;
            const key = 'inventory_type';
            this.setProductAttribute({ key, value });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/product/product-inventory.vue